import icons from "./icons";
export default (str, size = 20) => {
  let text = str;
  for (let key in icons) {
    if (icons.hasOwnProperty(key)) {
      let reg = new RegExp(`#${icons[key]}#`, "ig");
      let img = require(`@/assets/emoji/newqq/${key}.gif`);
      text = text.replace(
        reg,
        `<img style="display:inline-block;width:${size}px;height:${size}px;" src="${img}">`
      );
    }
  }
  return text;
};
